// bulkUploadSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
};

const bulkUploadSlice = createSlice({
  name: "bulkUploadData", 
  initialState,
  reducers: {
    addBulkAgreementAction: (state, action) => {
      state.data = action.payload; 
    },

    // Action to edit an existing object by its id
    editBulkAgreementAction: (state, action) => {
      const { id, key, value } = action.payload;
      const objectToEdit = state.data.find((item) => item.uid === id);
      if (objectToEdit) {
        objectToEdit[key] = value; // Edit the specific key-value pair
      }
    },

    // Action to delete an object by its id
    deleteBulkAgreementAction: (state, action) => {
      state.data = state.data.filter((item) => item.uid !== action.payload); // Remove object by id
    },
  },
});

// Export actions to be used in components
export const { addBulkAgreementAction, editBulkAgreementAction, deleteBulkAgreementAction } = bulkUploadSlice.actions;

// Export the reducer to be used in the store
export default bulkUploadSlice.reducer;
